<template>
    <div class="position-box">
        <span class="normal-span" tkey="店鋪位置">{{i18n.tkey("lang_shop_position")}}</span>：
        <el-link type="primary" class="link-span" @click="clickPositionSpan">{{positionText}}</el-link>&nbsp;
        <copyButton @click="copyShareUrl" />

        <el-popover placement="bottom" :width="174" trigger="hover" v-if="showQRCode === true">
            <template #reference>
                <qrcodeButton />
            </template>
            <qrcodeComponents v-if="null != positionUrl" :url="positionUrl" :width="150" :height="150" />
        </el-popover>
      <div style="margin-top: 8px;">
        <span>{{i18n.tkey("lang_store_status")}}：</span>
        <el-select v-model="productverify" style="width: 80px" @change="changeStoreStatus" >
          <el-option
              :key="-1"
              :label="i18n.tkey('lang_close')"
              :value="-1"
          />
          <el-option
              :key="0"
              :label="i18n.tkey('lang_open')"
              :value="0"
          />
        </el-select>
      </div>
    </div>
</template>

<script setup>
    import {toRef, ref, computed, getCurrentInstance, onMounted, inject} from "vue";
    import { useUserinfo } from '@/stores/userinfo'
    import qrcodeComponents from "@/components/shopopee/common/qrcodeComponents"
    import qrcodeButton from "@/components/shopopee/button/qrcodeButton"
    import copyButton from "@/components/shopopee/button/copyButton"
    import copy from "clipboard-copy";
    import util from "@/util/util";
    import {usePageinfo} from "@/stores/pageinfo";
    import myUtil from "@/util/util";
    import companyApi from "@/request/companyApi";

    const props = defineProps(["showQRCode"])
    const { proxy } = getCurrentInstance()

    const { getShopCompanyObj } = inject('shopControlFunc', { getShopCompanyObj: () => { return null } })
    const shopCompany = ref(null)

    const i18n = inject("i18n")

    const reload = inject("reload");

    const userInfoRef = toRef(useUserinfo())
    const pageInfoRef = toRef(usePageinfo())
    const positionUrl = ref(null)
    const productverify = ref(0)

    console.log(proxy.$route)
    const positionText = computed(() => {
        if (userInfoRef.value.wa == null || userInfoRef.value.siojournal == null){
            return "-"
        }

        if (null == shopCompany.value){
            return `${userInfoRef.value.wa}-${userInfoRef.value.siojournal}`
        }else{
            if(myUtil.isEmpty(shopCompany.value.productverify)){
              productverify.value = 0
            }else {
              productverify.value= shopCompany.value.productverify
            }
            return `${shopCompany.value.wa}-${shopCompany.value.siojournal}`
        }

    })

    function changeStoreStatus(){
      if (null != shopCompany.value){
        const request = companyApi.updateCompanyProductverify
        const params = request.getParams()

        params.companycode = shopCompany.value.companycode
        params.productverify = productverify.value

        request.send(params, (res) => {
          console.log(res)
          if (res.code != 200){
              console.log(productverify.value)
             // productverify.value = ""
          }
        })
      }
    }

    function copyShareUrl(){
        copy(positionUrl.value)
        util.alertSuccess(i18n.tkey("lang_copy_success"))
    }

    function clickPositionSpan(){
        let params = {}

        if (null == shopCompany.value){
            params = {
                countrycode: userInfoRef.value.countrycode,
                rid: userInfoRef.value.wa,
                did: userInfoRef.value.siojournal,
            }
        }else{
            params = {
                countrycode: shopCompany.value.countrycode,
                rid: shopCompany.value.wa,
                did: shopCompany.value.siojournal,
            }
        }

        pageInfoRef.value.userFrom = 0

        // proxy.$router.push({
        //     name: "indexCid",
        //     params: params
        // })
        //
        // reload()

        location.href = positionUrl.value

    }

    onMounted(() => {
        shopCompany.value = getShopCompanyObj()

        if (null == shopCompany.value){
            if (userInfoRef.value.wa != null && userInfoRef.value.siojournal != null){
                const path = process.env.NODE_ENV === 'production' ? "3d/index" : "index"

                positionUrl.value = `${proxy.$ShopopeeUrl}${path}/${shopCompany.value.countrycode}/${userInfoRef.value.wa}/${userInfoRef.value.siojournal}`
            }
        }else{
            if (null == shopCompany.value.additionalrecord15){
              positionUrl.value = `${proxy.$ThreeDShopopeePath}/index/${shopCompany.value.countrycode}/${userInfoRef.value.wa}/${userInfoRef.value.siojournal}`
            }else{
               // const islandID = shopCompany.value.additionalrecord15.updatedid

                positionUrl.value = `${proxy.$ThreeDShopopeePath}landShop/${shopCompany.value.countrycode}/${shopCompany.value.additionalrecord15.id}`

             // positionUrl.value = `${proxy.$ThreeDShopopeePath}${islandID}/index/${shopCompany.value.countrycode}/${userInfoRef.value.wa}/${userInfoRef.value.siojournal}`
            }

        }

    })
</script>

<style scoped>
    .normal-span {
        font-size: 14px;
        color: #303133;
    }

    .link-span {
        font-size: 1.2em;
    }

    .position-box {
        text-align: left;
    }
</style>